var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.editItemOpen
        ? _c("edit-item-modal", {
            attrs: { showEditItem: _vm.editItemOpen },
            on: { "close-modal": _vm.closeEditItem },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showCart
        ? _c("div", { staticClass: "cart" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.closeCart,
                    expression: "closeCart",
                  },
                ],
              },
              [
                _c("cart-header", {
                  attrs: {
                    showSpinner: _vm.cartIsLoading,
                    showStaffCartInfo: _vm.cart.showStaffCartInfo,
                    showPhone: _vm.cart.showPhone,
                    firstNameShow: _vm.cart.firstNameShow,
                    lastNameShow: _vm.cart.lastNameShow,
                  },
                  on: { "close-cart": _vm.closeCart },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cart-body" },
                  [
                    _vm.cart.showChooseZone
                      ? _c("div", { staticClass: "zone-information" }, [
                          _vm._v("\n          Delivery Zone:\n          "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "/selectZone.pl?goloc=chooseRestaurant.pl",
                              },
                            },
                            [_vm._v(_vm._s(_vm.cart.chooseZone))]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.cart.orders, function (order) {
                      return _c("cart-orders", {
                        key: order.id,
                        attrs: {
                          order: order,
                          showStaffCartInfo: _vm.cart.showStaffCartInfo,
                        },
                        on: {
                          "edit-item": _vm.handleEditItem,
                          "remove-item": _vm.handleRemove,
                          "clear-order": _vm.handleClearOrder,
                          "edit-item-qty": _vm.handleEditItemQty,
                          updateRestComment: _vm.handleUpdateRestComment,
                          "close-cart": _vm.closeCart,
                        },
                      })
                    }),
                    _vm._v(" "),
                    _vm.cart.showStaffCartInfo
                      ? _c("cart-fee-summary", {
                          attrs: {
                            subtotal: _vm.cart.subtotal,
                            taxService: _vm.taxService,
                            delivery: _vm.cart.delivery,
                            couponAdj: _vm.couponAdjustment,
                            gratuity: _vm.cart.gratuityAmount,
                            minFee: _vm.cart.difference,
                            custIsPayingMinFee: _vm.cart.custIsPayingMinFee,
                            utensilsPrice: _vm.cart.utensilsPrice,
                            utensilsApplied: _vm.cart.utensilsApplied,
                            taxAmount: _vm.cart.taxAmount,
                            serviceFee: _vm.cart.serviceFee,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cart.showStaffCartInfo
                      ? _c("cart-gratuity-picker", {
                          attrs: {
                            options: _vm.cart.gratuityOptions,
                            message: _vm.cart.gratuityMessage,
                            gratuityPercent: _vm.cart.gratuityPercent,
                            gratuityAmount: _vm.cart.gratuityAmount,
                          },
                          on: { "gratuity-change": _vm.setGratuity },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.tipErrors.minimum && _vm.cart.showStaffCartInfo
                      ? _c(
                          "div",
                          {
                            staticClass: "min-status-text",
                            attrs: {
                              tabindex: "0",
                              "aria-label": _vm.tipErrors.minimum,
                            },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "fas fa-exclamation-circle alert-icon",
                            }),
                            _vm._v(" \n          "),
                            _c("span", [_vm._v(_vm._s(_vm.tipErrors.minimum))]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cart.showStaffCartInfo
                      ? _c("cart-coupon", {
                          ref: "coupon",
                          attrs: {
                            value: _vm.cart.couponName,
                            isCouponApplied: _vm.isCouponApplied,
                          },
                          on: {
                            input: _vm.handleCouponNameChange,
                            "remove-coupon": _vm.handleRemoveCoupon,
                            "apply-coupon": _vm.handleApplyCoupon,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cart.showStaffCartInfo
                      ? _c("cart-total", { attrs: { total: _vm.cart.total } })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cart.orders.length &&
                    (!_vm.cart.minMetOrOverridden ||
                      _vm.cart.minimumStatus === 4)
                      ? _c(
                          "div",
                          {
                            staticClass: "min-status-text",
                            attrs: {
                              tabindex: "0",
                              "aria-label": _vm.minStatusText,
                            },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "fas fa-exclamation-circle alert-icon",
                            }),
                            _vm._v(
                              " \n          " +
                                _vm._s(_vm.minStatusText) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showPayTheDifference
                      ? _c("div", { staticClass: "min-status-text" }, [
                          _vm.cart.custIsPayingMinFee
                            ? _c(
                                "label",
                                {
                                  staticClass: "visuallyHidden",
                                  attrs: { for: "paydifference" },
                                },
                                [_vm._v("Click to remove minimum fee.")]
                              )
                            : _c(
                                "label",
                                {
                                  staticClass: "visuallyHidden",
                                  attrs: { for: "paydifference" },
                                },
                                [_vm._v("Click to pay the minimum fee.")]
                              ),
                          _vm._v(" "),
                          _c("input", {
                            attrs: { id: "paydifference", type: "checkbox" },
                            domProps: { checked: _vm.cart.custIsPayingMinFee },
                            on: {
                              click: function ($event) {
                                return _vm.submitPayMinFee()
                              },
                            },
                          }),
                          _vm._v(
                            "  (Just pay the\n          difference)\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.cart.orders.length
                      ? _c(
                          "div",
                          { staticClass: "empty-cart-container" },
                          [
                            _c("icon-cart-outline"),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "Your Cart is empty! Add items to get started."
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.cart.showStaffCartInfo && _vm.cart.orders.length
                      ? _c(
                          "div",
                          {
                            staticClass: "taxes-fees-message",
                            attrs: {
                              tabindex: "0",
                              "aria-label":
                                "Taxes & Fees calculated at checkout.",
                            },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "fas fa-exclamation-circle alert-icon",
                            }),
                            _vm._v(
                              "  Taxes & Fees calculated at checkout.\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cart.showSendToQueue
                      ? _c(
                          "cart-button",
                          { on: { "submit-cart": _vm.sendToQueue } },
                          [_vm._v("Send Back To Queue ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cart.orders.length && !_vm.cart.showSendToQueue
                      ? _c(
                          "cart-button",
                          {
                            attrs: {
                              disabled: !_vm.cart.minMetOrOverridden,
                              "aria-label": `Go To Checkout ${_vm.getAmountLabel}`,
                            },
                            on: { "submit-cart": _vm.submit },
                          },
                          [_vm._v(_vm._s(_vm.getAmountShow))]
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }